/* eslint-disable quote-props */
import React from "react";
import { FormControlLabel, FormControlLabelProps, styled, useRadioGroup } from "@mui/material";

interface StyledFormControlLabelProps extends FormControlLabelProps {
  checked: boolean;
  defaultChecked?: boolean;
}

const StyledFormControlDefaultLabel = styled((props: StyledFormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  alignItems: "flex-start",
  margin: "8px 0",
  "& .MuiFormControlLabel-label": {
    marginTop: ".6rem",
    width: "100%",
  },
}));

const StyledFormControlCardLabel = styled((props: StyledFormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({ theme, checked, defaultChecked }) => ({
  borderWidth: "2px",
  borderStyle: defaultChecked? "": "solid",
  borderColor: checked ? theme.palette.primary.main : "transparent",
  borderRadius: "8px",
  padding: "1rem",
  backgroundColor: checked ? "#fff" : "#fff",
  margin: "8px 0",
  width: "100%",
  boxSizing: "border-box",
  "& .MuiButtonBase-root": {
    padding: 0,
    marginRight: "10px",
  },
  "&.error": {
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.error.light,
  },
}));

const StyledFormControlVerticalLabel = styled((props: StyledFormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  margin: "8px 0",
  display: "grid",
  textAlign: "center",
  "& .MuiFormControlLabel-label": {
    fontWeight: "bold",
    fontSize: "16px",
  },
}));

const StyledFormControlBlockLabel = styled((props: StyledFormControlLabelProps) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: 0,
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: checked ? theme.palette.primary.main : "#E8DFD7",
  borderRadius: "8px",
  padding: "8px",
  backgroundColor: "#fff",
  "&.Mui-disabled": {
    backgroundColor: "#ffffff80",
  },
  "& .MuiRadio-root": {
    display: "none",
  },
  "&.Mui-disabled .MuiTypography-root": {
    color: "rgba(0, 0, 0, 0.38)",
  },
  "&.error": {
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.error.light,
  },
}));


interface IFormControlLabelProps extends FormControlLabelProps {
  variant?: "default" | "card" | "vertical" | "block",
}
const MyFormControlLabel = (props: IFormControlLabelProps) => {
  const radioGroup = useRadioGroup();
  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <>
    {props.variant === "default" ? (<StyledFormControlDefaultLabel checked={checked} {...props} />) : null}
    {props.variant === "card" ? (<StyledFormControlCardLabel checked={checked} {...props} />) : null}
    {props.variant === "vertical" ? (<StyledFormControlVerticalLabel checked={checked} {...props} />) : null}
    {props.variant === "block" ? (<StyledFormControlBlockLabel checked={checked} {...props} />) : null}
  </>;
};

export default MyFormControlLabel;
